import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DateFormat, Timezone } from '@cdw-ae/common-data';
import { Observable } from 'rxjs';
import { ApiUrlBuilderService } from '../api-url-builder.service';

export interface UpdateCustomerSettingsDto {
  timezone?: Timezone;
  dateFormat?: DateFormat;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerSettingsService {
  private readonly http = inject(HttpClient);
  private readonly urlBuilder = inject(ApiUrlBuilderService);

  /**
   * Update timezone and date format for the authenticated customer.
   * Customer ID is derived from the token server-side — do not pass it in the URL.
   */
  updateDateTimeSettings(
    settings: UpdateCustomerSettingsDto
  ): Observable<void> {
    const url = this.urlBuilder.backendApi('customer', 'settings');
    return this.http.patch<void>(url, settings);
  }
}
